/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ofType } from 'redux-observable';
import { of, combineLatest } from 'rxjs';
import { withLatestFrom, pluck, mergeMap } from 'rxjs/operators';
import values from 'lodash/values';
import isNil from 'lodash/isNil';
import size from 'lodash/size';
import forEach from 'lodash/forEach';
import { sortAvailability } from '../../utils/availabilityReducerUtil';
import {
    SORT_AVAILABILITIES_COMPLETE,
    SET_SORT_PROPERTY,
    SET_GRID_RANGE,
    PROCESS_AVAILABILITY_COMPLETE,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const sortAvailabilityEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            PROCESS_AVAILABILITY_COMPLETE, // when new campsite monthly availability data are fetched
            SET_SORT_PROPERTY, // when filter input changes
            SET_GRID_RANGE // when grid view changes
        ),
        withLatestFrom(
            combineLatest(
                state$.pipe(pluck('availabilityGrid')),
                state$.pipe(pluck('orderDetails'), pluck('pendingReservations')),
                state$.pipe(
                    pluck('internalCamping'),
                    pluck('orderDetails'),
                    pluck('pendingReservations')
                )
            )
        ),
        mergeMap((stream) => {
            const states = stream[1];
            const [availabilityGrid, reservations, internalReservations] = states;
            const { sort, originalAvailabilitiesMap, gridStartDate, selections } =
                availabilityGrid;

            const pendingReservations = isNil(reservations)
                ? internalReservations
                : reservations;
            const reservation = values(pendingReservations)[0];

            const { isSortAsc, sortedColumnId } = sort;

            const sortedAvailabilities = sortAvailability({
                campsiteAvailabilityMap: originalAvailabilitiesMap,
                isSortAsc,
                sortedColumnId,
                reservation,
                gridStartDate,
            });

            let scrollToCampsite = null;
            if (sortedColumnId === 'AVAILABILITY' && size(selections) > 0) {
                let furthestCampsite = null;
                forEach(selections, (sel) => {
                    if (!furthestCampsite) furthestCampsite = sel;
                    furthestCampsite =
                        sel.endDate > furthestCampsite.endDate ? sel : furthestCampsite;
                });
                scrollToCampsite = furthestCampsite.campsiteId;
            }

            return of({
                type: SORT_AVAILABILITIES_COMPLETE,
                payload: sortedAvailabilities,
                scrollToCampsite,
            });
        })
    );
